module.exports = {
	"pagination": {
		"DescribeDocumentVersions": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "DocumentVersions"
		},
		"DescribeFolderContents": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": [
				"Folders",
				"Documents"
			]
		},
		"DescribeUsers": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "Users"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/workdocs-2016-05-01.paginators.json
// module id = 497
// module chunks = 0